import { makeStyles } from '@material-ui/core'

export const useStyles = makeStyles(theme => ({
  title: {
    textAlign: 'center',
    fontFamily: 'Roboto',
    fontWeight: 600,
    fontSize: '2.5rem',
    lineHeight: '135%',
    color: '#353535',
  },
  boxAlign: {
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'center',
    marginTop: '2rem',
    gap: '1rem',
    width: '100%',
    [theme.breakpoints.down(1300)]: {
      flexDirection: 'column',
    },
  },
  subtitle: {
    textAlign: 'center',
    fontFamily: 'Roboto',
    fontWeight: 700,
    fontSize: '1.5rem',
    lineHeight: '135%',
    color: '#353535',
    marginBottom: '1rem',
    display: 'block',
    width: '100%',
  },
  updatedIn: {
    textAlign: 'center',
    fontFamily: 'Roboto',
    fontWeight: 400,
    fontSize: '1.0rem',
    lineHeight: '135%',
    color: '#353535',
    marginBottom: '1rem',
    display: 'block',
    width: '100%',
  },
  buttonsAlign: {
    display: 'flex',
    justifyContent: 'space-evenly',
    marginTop: '1rem',
    marginBottom: '1.5rem',
  },
  redirectUser: {
    marginTop: '4rem',
  },
  centralizeButton: {
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'column',
    justifyContent: 'center',
  },
  header: {
    justifyContent: 'space-between',
    margin: '0 auto',
    display: 'flex',
    alignItems: 'center',
    width: '45rem',
    [theme.breakpoints.between(0, 550)]: {
      width: '25rem',
    },
    [theme.breakpoints.between(0, 350)]: {
      width: 'auto',
    },
  },
  boxDate: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    width: '10rem',
    border: '1px solid #C4C4C4',
    padding: '0.9rem 1rem',
  },
  rankings: {
    width: '48%',
    [theme.breakpoints.down(1300)]: {
      width: '100%',
    },
  },
}))
